var s=class r extends Error{constructor(e){super(e.message);Object.setPrototypeOf(this,r.prototype),typeof e.name=="string"&&(this.name=e.name),typeof e.message=="string"&&(this.message=e.message);}};

export { s as a };
